import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';

// Styles

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const OptionTitle = ({ icon, title }) => {
  const IconComponent = icon;

  return (
    <div className={cx('title')}>
      <div className={cx('title__wrap')}>
        {icon && (
          <div className={cx('title__image')}>
            <IconComponent />
          </div>
        )}
        <span className={cx('title__label')}>
          <Text size="size6-r">
            {title}
          </Text>
        </span>
      </div>
    </div>
  );
};

OptionTitle.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
  ]),
};

export { OptionTitle };
